import React from 'react'
import Link from 'gatsby-link'
import classnames from 'classnames'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import SvgIcon from '@material-ui/core/SvgIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { withStyles } from '@material-ui/core/styles'

import { fragBlog, fragPost } from '../utils/fragments'
import { mapPost, mapBlog, mapMetaData } from '../utils/mapper'

import styles from '../styles/site'

import BlogIcon from '../img/icons/blog.svg'

import MetaData from '../components/metadata'
import Banner from '../components/banner'
import Quote from '../components/quote'
import Footer from '../components/footer'

const BlogPage = props => {
  const { classes } = props
  const metadata = mapMetaData(props.data.blog)
  const blog = mapBlog(props.data.blog)

  const all = props.data.all.edges.map(post => {
    return mapPost(post.node)
  })

  return (
    <div>
      <MetaData data={metadata} />
      <Banner uid="blog" title={blog.title} subtitle={blog.subtitle} />
      <Teaser image={blog.featured_bg} />
      <Focus blog={blog.featured_post} />
      {blog.list.map((post, index) => {
        return (
          <div key={index}>
            <Content post={post} />
          </div>
        )
      })}
      <BlogNav all={all} featured={blog.list} />
      <Footer policies={props.data.policies.edges}/>
    </div>
  )
}

const Teaser = withStyles(styles)(props => {
  const { classes, image } = props

  return (
    <Hidden xsDown>
      <div className={classes.teaser}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <div
              style={{
                background: `url(${image.src})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                height: '40vh',
              }}
            />
          </Grid>
        </Grid>
      </div>
    </Hidden>
  )
})

const Focus = withStyles(styles)(props => {
  const { classes, blog } = props
  let LinkButton = props => <Link to={`/blog/${blog.uid}`} {...props} />
  return (
    <div>
      <Hidden xsDown>
        <div className={classes.focus}>
          <div className={classes.contents}>
          <div className={classnames(classes.focusFloat, classes.focusFloatBlog)}>
              <Grid container spacing={40} className={classes.focusText}>
                <Grid item xs={12}>
                  <Typography className={classes.focusSub} gutterBottom>
                    {blog.data.title.text}
                  </Typography>
                  <Typography className={classes.focusText}>
                    {blog.data.lead.text}
                  </Typography>
                  <Button
                    component={LinkButton}
                    className={classnames(
                      // classes.postlistLink,
                      classes.focusLink
                    )}
                  >
                    Read more
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </Hidden>
    </div>
  )
})

const Content = props => {
  const { post } = props
  return post.type === 'blog_list' ? (
    <PostList blogs={post.contents} />
  ) : post.type === 'blog_quote' ? (
    <Quote quote={post.quote} />
  ) : null
}

const PostList = withStyles(styles)(props => {
  const { classes, blogs } = props

  return (
    <div className={classes.postlist}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Hidden xsDown>
            <Grid container spacing={16}>
              {blogs.map((blog, index) => {
                return (
                  <Grid key={index} item xs={6}>
                    <Post  blog={blog} classes={classes} />
                  </Grid>
                )
              })}
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid container>
              <Grid item xs={12}>
                {blogs.map((blog, index) => {
                  return <Post key={index} blog={blog} classes={classes} />
                })}
              </Grid>
            </Grid>
          </Hidden>
        </div>
      </div>
    </div>
  )
})

const Post = props => {
  const { classes, blog, index } = props

  let LinkButton = props => <Link to={`/blog/${blog.uid}`} {...props} />
  return (
    <div key={index} className={classes.posts}>
      <Grid container spacing={40} className={classes.postItem}>
        <Grid item xs={12}>
          <div
            className={classes.postThumbnail}
            style={{ backgroundImage: `url(${blog.post_bg.src})` }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="title" gutterBottom>
            {blog.title.text}
          </Typography>
          {blog.author && (
            <Typography variant="caption" className={classes.postAuthor}>
              {blog.author.author_name.text}
            </Typography>
          )}
          <Typography variant="caption">{blog.published}</Typography>
          <Typography className={classes.postlistText}>
            {blog.lead.text}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button component={LinkButton} className={classes.postlistLink}>
            Read more
            {/* <ChevronRight className={classes.rightIcon} /> */}
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

const BlogNav = withStyles(styles)(props => {
  const { all, featured, classes } = props
  return (
    <div className={classes.blogStudyNavItems}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container spacing={40}>
            <Grid item className={classes.title}>
              <Typography variant="headline" className={classes.blogStudyNavTitle}>
                All Posts
              </Typography>
              {all.map(item => {
                let active = false
                featured.map(list => {
                  if (list.type === 'blog_list') {
                    list.contents.find(x => {
                      if (x.uid === item.uid) {
                        active = true
                      }
                    })
                  }
                })
                return (
                  <ListItem key={item.uid} button component={Link} to={`/blog/${item.uid}`}>
                    <img src={BlogIcon} className={classes.blogStudyNavIcon} />
                    <ListItemText
                      primary={item.title.text}
                      secondary={(item.author.name == null) ? null : item.author.name.text}
                      classes={{
                        primary: classes.blogStudyItemHead,
                        secondary: classes.blogStudyItemSub
                      }}
                    />
                  </ListItem>
                )
              })}
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(BlogPage)

export const query = graphql`
  query blogQuery {
    blog: prismicCtBlogs {
      ...blog
    }
    all: allPrismicCtBlog(filter: { tags: { regex: "/^((?!test).)*$/" }}) {
      edges {
        node {
          ...post
        }
      }
    }

    policies: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {
              
              text
            }
            
            
          }
      }
      }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.js